import { render } from "./CustomSlider.vue?vue&type=template&id=146c4049&scoped=true&ts=true"
import script from "./CustomSlider.vue?vue&type=script&lang=ts"
export * from "./CustomSlider.vue?vue&type=script&lang=ts"

import "./CustomSlider.vue?vue&type=style&index=0&id=146c4049&scoped=true&lang=scss"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/guinong-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-146c4049"]])

export default __exports__